import type { ReactNode } from "react";
import Button from "~/components/common/Button";
import styles from "./ConfirmModal.module.css";

type ConfirmModalProps = {
  open: boolean;
  title: string;
  content?: ReactNode;
  okText: string;
  cancelText?: string;
  /** 单按钮模式：隐藏 ghost 取消按钮（遮罩点击仍触发 onCancel） */
  hideCancel?: boolean;
  okDanger?: boolean;
  okDisabled?: boolean;
  onOk: () => void;
  onCancel: () => void;
};

// 自绘确认弹窗，对齐设计稿 modal-mask / modal（mine.html / form.html）
const ConfirmModal = ({
  open,
  title,
  content,
  okText,
  cancelText = "取消",
  hideCancel = false,
  okDanger = false,
  okDisabled = false,
  onOk,
  onCancel,
}: ConfirmModalProps) => {
  if (!open) return null;

  return (
    <div
      className={styles.mask}
      onClick={onCancel}
    >
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.title}>{title}</div>
        {content != null && <div className={styles.body}>{content}</div>}
        <div className={styles.btns}>
          {!hideCancel && (
            <Button
              size="sm"
              ghost
              disabled={okDisabled}
              onClick={onCancel}
            >
              {cancelText}
            </Button>
          )}
          <Button
            size="sm"
            className={okDanger ? styles.danger : undefined}
            disabled={okDisabled}
            onClick={onOk}
          >
            {okText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
